import React from 'react';
import { Button, BackButton, ResultValue, PrintButton } from '../Components/Simple';
import { BasicInformation, ClaimDetails, FactorAndAdjustments, Comorbidities, PricingErrors, PricingAmounts } from '../Components/Combined/Results';
import { PSYCH } from '../Constants/modelTypes';
import { formatStringAsCurrency, formatDateString } from '../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats';
import { useNavigate, useLocation } from 'react-router-dom';
import DRGResults from '../Components/Results/DRGResults';
import Protect from '../Components/Combined/Protect';
import { HIDE } from '../Constants/protectionBehaviors';
import { EOB_VIEW } from '../Constants/moduleNames';
import { enableEOB } from '../Utils/features';

export default function IPPyschResult() {
    const location = useLocation();
    const navigate = useNavigate();
    const { result, fiscalYear, dateOfBirth, drgServiceMode } = location.state;

    const processedDate = new Date();

    const handleNavigateToEOBGenerator = () => {
        const fromDate = formatDateString(result.fromDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
        const toDate = fromDate && formatDateString(result.toDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
        navigate('/EOB', {
            state: {
                processedDate,
                pricerType: PSYCH,
                lines: [{
                    dateOfService: toDate && `${fromDate} - ${toDate}`,
                    serviceCode: "",
                    serviceDescription: "IP Hospital Services",
                    qty: "",
                    billedAmount: parseFloat(result.totalBilled) || 0,
                    allowedAmount: parseFloat(result.medicareAllowed) || 0,
                    initialMaxShiftAmount: 0
                }]
            }
        });
    };

    return (<div className="py-2">
        <div className="row g-0 sticky top border-bottom">
            <div className="row justify-content-between g-0">
                <div className="col-auto">
                    <PrintButton />
                </div>
                <div className="col-auto">
                    <Protect module={EOB_VIEW} behavior={HIDE} >
                        {enableEOB && <Button className="btn btn-success" onClick={handleNavigateToEOBGenerator} text="Generate EOB" />}
                    </Protect>
                </div>
                <div className="col-auto">
                    <BackButton />
                </div>
            </div>
            <div className="row my-2 g-0">
                <div className="col">
                    <h2>IP Psych Pricer - Pricing Outputs</h2>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <ResultValue label="Medicare Allowed Amount" value={formatStringAsCurrency(result.medicareAllowed)} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
            </div>
        </div>
        <PricingErrors result={result} totalMedicareAllowed={result.medicareAllowed} />
        <div className="row my-2">
            <div className="col-md-6">
                <BasicInformation fiscalYear={fiscalYear} result={result} model={PSYCH} processedDate={processedDate} />
            </div>
        </div>
        <div className="row my-2">
            <div className="col-md">
                <ClaimDetails result={result} model={PSYCH} dateOfBirth={dateOfBirth} />
            </div>
            <div className="col-md">
                <FactorAndAdjustments result={result} model={PSYCH} />
            </div>
        </div>
        <div className="row my-2">
            <div className="col-md-6">
                <PricingAmounts result={result} model={PSYCH} />
            </div>
        </div>
        <div className="row my-2">
            <div className="col-md-6">
                <Comorbidities result={result} />
            </div>
        </div>
        <DRGResults result={result} serviceMode={drgServiceMode} />
    </div>
    );
}
